import { apiGet } from 'utils/API/actions/request'
import { DASHBOARD } from '../constants'

export const featchDashboard = (appId) => apiGet({
  entity: DASHBOARD,
  url: `/dashboard/${appId}`,
  isChainable: true
})